import React from 'react';
// import ReactGA from 'react-ga';
import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { RecoilRoot } from 'recoil';
import { BrowserRouter as Router } from 'react-router-dom';
// import { ReactKeycloakProvider } from '@react-keycloak/web';

// import keycloak from './keycloak';
import BaseLayout from './components/BaseLayout';
// import Loader from './components/Loader';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function App() {
  // ReactGA.initialize('UA-200250898-1');
  // ReactGA.pageview(window.location.pathname + window.location.search);

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: '#1d4f91',
      },
      secondary: {
        main: '#06a6b6',
      },
    },
    typography: {
      fontFamily: ['Fira Sans', 'Arial', 'sans-serif'].join(','),
    },
    overrides: {
      MuiButton: {
        containedSecondary: {
          color: '#fff',
          textTransform: 'none',
          fontFamily: "'Fira Sans Bold', Arial, sans-serif",
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
          minWidth: 'unset',
        },
      },
      MuiCssBaseline: {
        '@global': {
          body: {
            backgroundColor: '#fff',
          },
        },
      },
    },
  });

  return (
    <div className="allergy-marketplace-app-container">
      {/* <ReactKeycloakProvider
        authClient={keycloak}
        initOptions={
          {
            // onLoad: 'login-required',
            // flow: 'implicit',
          }
        }
        LoadingComponent={<Loader />}
        onEvent={(event) => {
          if (event === 'onReady' && window.zE) {
            window.zE('webWidget', 'show');
          }
        }}
      > */}
      <RecoilRoot>
        <ThemeProvider theme={theme}>
          <Router>
            <CssBaseline />
            <BaseLayout />
          </Router>
        </ThemeProvider>
      </RecoilRoot>
      {/* </ReactKeycloakProvider> */}
    </div>
  );
}

export default App;
